import styled from "styled-components";
import {
	TABLET_M_BP,
	MOBILE_L_BP,
	TABLET_BP,
} from "@website-builder/utilities/constants/style-constants/screen-sizes.js";

export const Wrapper = styled.div`
	padding: 80px 0;
	background-color: ${({ backgroundColor, darkBg }) =>
		backgroundColor
			? backgroundColor
			: `var(
  ${darkBg ? "--primary-forest-600" : "--primary-green-50"}
  )`};
	position: relative;
	overflow: hidden;

	.content {
		position: relative;
		z-index: 2;
		gap: 0;
	}
	.three-up-content {
		margin-inline: 0;
	}
	.centered-text {
		text-align: center;
		margin-bottom: 40px;
	}
	.padding-top {
		padding-top: 1.5rem;
	}
	.btn {
		display: block;
		margin: 64px auto 0 auto;
		font-weight: var(--fw-work-sans-3);
	}

	@media only screen and (max-width: ${TABLET_M_BP}px) {
		.centered-text {
			margin-bottom: 32px;
		}
		.three-up-content .centered-text {
			padding: 0 24px;
		}
		.padding-top {
			padding-top: 1rem;
		}
		.btn {
			${(p) =>
				p.hideNav ? "margin: 32px auto 0 auto;" : "margin: 70px auto 0 auto;"}
		}
		.three-up-content {
			.btn {
				margin: 32px auto 0 auto;
			}
		}
	}

	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		.three-up-content {
			.btn-col {
				margin-inline: 24px;
			}
		}
	}

	${(p) =>
		p.hideNav
			? `
  .slick-dots {
      display: none;
  }
  `
			: null}
`;

export const ImageTestimonialWrapper = styled.div`
	.slider-container {
		margin: 0 auto;
		max-width: 1000px;

		.slick-slider {
			height: 500px;
			box-shadow:
				0px 78px 31px rgba(0, 0, 0, 0.01),
				0px 44px 26px rgba(0, 0, 0, 0.02),
				0px 20px 20px rgba(0, 0, 0, 0.03),
				0px 5px 11px rgba(0, 0, 0, 0.04),
				0px 0px 0px rgba(0, 0, 0, 0.04);
		}
		.slick-slide {
			height: 100%;
		}
	}

	.content-flex {
		margin: 0;
		padding: 0;
		height: 504px;
		border-radius: 8px;
		display: flex;

		.cloudinary-image-container {
			flex: 1;
			height: 100%;
			width: 100%;
			max-width: 412px;
			display: inline-block;
			img {
				width: 100%;
				height: 100%;
				object-fit: cover;
				border-top-left-radius: 8px;
				border-bottom-left-radius: 8px;
			}
		}

		.text-container {
			flex: 1;
			background-color: var(--primary-neutral-white);
			border-top-right-radius: 8px;
			border-bottom-right-radius: 8px;
		}
		.inner-text-container {
			margin: 32px;
			overflow: scroll;

			.text-label {
				display: block;
				margin-bottom: 1.5rem;
			}
			.text-quote {
				margin: 0.5rem 0 2rem 0;
				overflow-y: scroll;
				max-height: 178px;
				@media only screen and (max-width: ${TABLET_BP}px) {
					height: 178px;
				}
			}
			.student-info {
				margin: 0.5rem 0 1rem 0;
				& > *:not(:last-child) {
					margin-bottom: 0.25rem;
				}
				.gray-text {
					color: var(--secondary-gray-dark);
				}
			}
		}
	}

	@media only screen and (max-width: ${TABLET_BP}px) {
		.slider-container .slick-slider {
			height: auto;
		}

		.content-flex {
			flex-direction: column;
			height: min-content;

			.cloudinary-image-container {
				flex: unset;
				height: 250px;
				max-width: none;
				img {
					border-top-right-radius: 8px;
					border-bottom-left-radius: 0;
				}
			}
			.bottom-section {
				height: 160px;
			}
			.text-container {
				border-top-right-radius: 0;
				border-bottom-left-radius: 8px;
			}
		}
	}
`;

export const QuoteTestimonialWrapper = styled.div`
	.slider-container {
		margin: 0 auto;
		max-width: 750px;

		.slick-slider {
			box-shadow:
				0px 78px 31px rgba(0, 0, 0, 0.01),
				0px 44px 26px rgba(0, 0, 0, 0.02),
				0px 20px 20px rgba(0, 0, 0, 0.03),
				0px 5px 11px rgba(0, 0, 0, 0.04),
				0px 0px 0px rgba(0, 0, 0, 0.04);
		}
	}

	.slick-list {
		border-radius: 8px;
		background-color: var(--primary-neutral-white);
	}

	.content {
	}
	@media only screen and (max-width: ${TABLET_M_BP}px) {
		.slider-container {
			max-width: 620px;
		}
	}
`;

export const ThreeUpWrapper = styled.div`
	overflow-x: auto;

	.three-up-container {
		margin: 0 24px;
		display: flex;
		justify-content: center;
		column-gap: 1rem;
		flex-wrap: nowrap;

		.card-wrapper {
			flex: 1;
			min-width: 300px;
			max-width: 600px;
			border-radius: 8px;
		}
	}

	@media only screen and (max-width: ${TABLET_M_BP}px) {
		.three-up-container {
			justify-content: flex-start;
		}
	}
`;

export const QuoteCardContent = styled.div`
	background-color: var(--primary-neutral-white);
	border-radius: 8px;
	padding: 24px;
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	.text-label {
		display: block;
		margin-bottom: 1.5rem;
	}
	.text-quote {
		margin: 0.5rem 0 2rem 0;
		overflow-y: scroll;
		max-height: 178px;
	}
	.student-flex {
		margin-top: 0.5rem;
		display: flex;
		column-gap: 0.5rem;
		flex-wrap: nowrap;
		justify-content: space-between;
		.student-info {
			& > *:not(:last-child) {
				margin-bottom: 0.25rem;
			}
			.gray-text {
				color: var(--secondary-gray-dark);
			}
			.company-logo {
				margin-top: 0.75rem;
			}
		}
	}
`;

export const Image = styled.div`
	display: inline-block;
	margin: 0;
	padding: 0;
	border-radius: 50%;
	img {
		width: 4rem;
		height: 4rem;
		object-fit: cover;
		border-radius: 50%;
	}

	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		img {
			width: 56px;
			height: 56px;
		}
	}
`;
